import useSegment from '../../Hooks/useSegment'
import styles from './Share.module.scss'

import React, { useContext } from 'react'

import { v4 as uuidv4 } from 'uuid'

import { NotificationContext } from 'Contexts/NotificationContext/NotificationContext'

import Svg from 'Atoms/Svg'
import TextLink from 'Atoms/TextLink'

const Share = ({
  className,
  iconStyle,
  iconText,
  url,
  subtitle,
  title,
  tone,
  size,
  copy = true,
  segmentEvent,
  ...props
}) => {
  //url is optional: if not provided, the current location will be used.
  const { PushNotification } = useContext(NotificationContext)
  const { sendSegmentTrackEventWithName } = useSegment()

  const click = (e) => {
    e.stopPropagation()
    e.preventDefault()

    const shareGuid = uuidv4()

    const urlObject = !url.startsWith('http')
      ? new URL(
          `${window.location.origin}${window.location.origin.endsWith('/') || url.startsWith('/') ? '' : '/'}${url}`,
        )
      : new URL(url)

    urlObject.searchParams.append('utm_medium', 'referral')
    urlObject.searchParams.append('utm_source', 'share')
    urlObject.searchParams.append('utm_campaign', 'share')
    urlObject.searchParams.append('utm_content', shareGuid)
    url = urlObject.toString()

    if (navigator && navigator.share) navigator.share({ url: url, text: subtitle, title: title })

    if (copy) {
      if (navigator && navigator.clipboard) navigator.clipboard.writeText(url)
      PushNotification('Link copied to clipboard', null, 3000, null, {
        icon: 'check',
        intent: 'positive',
      })
    }

    if (segmentEvent) {
      try {
        segmentEvent.properties.share_guid = shareGuid
      } catch (e) {
        console.error(e)
      }

      sendSegmentTrackEventWithName(segmentEvent.event, segmentEvent.properties)
    }
  }

  return (
    <TextLink
      size={size}
      inline={className ? false : true}
      onClick={(e) => click(e)}
      data-testid={'share'}
      className={className}
      {...props}
    >
      <Svg
        size={size}
        tone={tone}
        icon={'share'}
        hoverable
        className={iconStyle ? iconStyle : iconText ? styles.share_icon : null}
      />{' '}
      {iconText}
    </TextLink>
  )
}

export default Share
